import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import MovieCategoryPage from "@/pages/category/movie/page";
import TvCategoryPage from "@/pages/category/tv/page";
import MovieDetailPage from "@/pages/detail/movie/page";
import TvDetailPage from "@/pages/detail/tv/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/category/movie",
        element: <MovieCategoryPage />,
      },
      {
        path: "/category/tv",
        element: <TvCategoryPage />,
      },
      {
        path: "/detail/movie/:id",
        element: <MovieDetailPage />,
      },
      {
        path: "/detail/tv/:id",
        element: <TvDetailPage />,
      },
      {
        path: "/search",
        element: <SearchPage />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;